import { KnowledgeUnit } from '../../types'

export interface CrossLevelResult {
  standardId: string
  typesByPass: Record<string, Record<string, number>> // passId → { type → count }
}

/**
 * For each standard, show the type distribution at each material level (pass).
 * Reveals whether different passes produce different KU type profiles.
 */
export function crossLevelConsistency(
  kus: KnowledgeUnit[],
  standardIds: string[],
  passIds: string[],
): CrossLevelResult[] {
  const results: CrossLevelResult[] = []

  for (const stdId of standardIds) {
    const stdKUs = kus.filter((ku) => ku.standard_id === stdId)
    if (stdKUs.length === 0) continue

    const typesByPass: Record<string, Record<string, number>> = {}
    for (const passId of passIds) {
      const passKUs = stdKUs.filter((ku) => ku.pass_id === passId)
      const dist: Record<string, number> = {}
      for (const ku of passKUs) {
        const t = ku.proposed_type || 'unclear'
        dist[t] = (dist[t] || 0) + 1
      }
      typesByPass[passId] = dist
    }

    results.push({ standardId: stdId, typesByPass })
  }

  return results
}
